export default "__VITE_ASSET__Ccen_ye4__"